import React, { useEffect } from "react";
import { Navigate, useParams } from "react-router-dom";
import HeaderBar from "./common/HeaderBar";
import FooterBar from "./common/FooterBar";
import { getPolicyBySlug, getPolicySections } from "../data/policies";

const PolicyPage = () => {
  const { slug } = useParams();
  const policy = getPolicyBySlug(slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!policy) return <Navigate to="/" replace />;

  return (
    <React.Fragment>
      <HeaderBar />
      <main className="mx-auto max-w-[900px] px-6 py-16 text-[15px] leading-8 text-[#2a2a2a]">
        <header className="mb-12 border-b border-black/10 pb-10 text-center">
          <p className="mb-3 text-[11px] uppercase tracking-[0.3em] text-black/50">
            {policy.group}
          </p>
          <h1 className="text-[32px] font-medium uppercase tracking-[3px] md:text-[38px]">
            {policy.title}
          </h1>
          <p className="mt-5 text-[13px] text-black/55">
            Effective October 26, 2026
          </p>
        </header>
        <div className="space-y-10">
          {getPolicySections(policy).map(({ heading, body }) => (
            <section key={heading}>
              <h2 className="mb-3 text-[18px] font-medium uppercase tracking-[1.5px]">
                {heading}
              </h2>
              <p>{body}</p>
            </section>
          ))}
        </div>
      </main>
      <FooterBar />
    </React.Fragment>
  );
};

export default PolicyPage;
